import { createContext, useContext } from 'react'
import type { PromptOption } from '../../PromptSelector'
import type { PromptModalResult } from '../../PromptModal'

export interface PromptManagementContextValue {
  promptOptions: Array<PromptOption>
  selectedPromptKey: string
  loadPrompts: () => Promise<void>
  handlePromptAdd: (result: PromptModalResult) => Promise<boolean>
  handlePromptSelect: (key: string) => void
}

const PromptManagementContext = createContext<PromptManagementContextValue | undefined>(undefined)

export const PromptManagementProvider = PromptManagementContext.Provider

export function usePromptManagementContext(): PromptManagementContextValue {
  const ctx = useContext(PromptManagementContext)
  if (!ctx) throw new Error('usePromptManagementContext must be used within PromptManagementProvider')
  return ctx
}
